module.exports = "mutation deleteTeamSave($id: Int!) {\n  deleteEntry(id: $id)\n}"